import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Basic configuration for i18n
i18n.use(initReactI18next).init({
  lng: "en", // Default language
  fallbackLng: "en", // Fallback language if the selected language is not available
  debug: true, // Enable debug mode for development (set to false for production)
  interpolation: {
    escapeValue: false, // React already escapes values to prevent XSS
  },
  resources: {}, // Placeholder for future translations
});

export default i18n;
